import {
  Bar
} from "vue-chartjs";

export default {
  name: "Home",
  extends: Bar,
  props: [
    "match",
    "simple",
    "multiple",
    "lost",
    "labels",
    "max"
  ],
  data: () => ({
    chartdata: {
      labels: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: 0,
            stepSize: 20,
          }
        }]
      }
    },

    gradient: ''
  }),

  mounted() {
    this.chartdata.datasets = [{
      label: this.$t('simple'),
      data: [],
      pointBackgroundColor: "white",
      borderWidth: 1,
      pointBorderColor: "white",
      backgroundColor: 'blue'

    }, {
      label: this.$t('double'),
      data: [],
      pointBackgroundColor: "white",
      borderWidth: 1,
      pointBorderColor: "white",
      backgroundColor: 'rgba(0,250,154, 1)',
    }, {
      label: this.$t('losts'),
      data: [],
      pointBackgroundColor: "white",
      borderWidth: 1,
      pointBorderColor: "white",
      backgroundColor: 'rgba(255,0,0, 1)',
    }, ]

    this.buildChart()
  },

  watch: {
    simple() {
      this.buildChart()
    },
    labels(val) {
      val.map(item => {
        this.chartdata.labels.push(item)
      });
    },
    max(val) {
      this.options.scales.yAxes[0].ticks.max = parseInt(val, 10);
    }

  },


  methods: {
    async buildChart() {
      this.chartdata.datasets[0].data = await this.simple
      this.chartdata.datasets[1].data = await this.multiple
      this.chartdata.datasets[2].data = await this.lost
      this.chartdata.labels = await this.labels
      this.options.scales.yAxes[0].ticks.max = await this.max;
      this.renderChart(this.chartdata, this.options);
    }
  },
};